import { alpha, Box, BoxProps, CircularProgress } from '@mui/material';

export const Spinner = ({ sx, ...rest }: BoxProps) => {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: (theme) =>
          alpha(theme.palette.background.default, 0.6),
        backdropFilter: 'blur(12px)',
        zIndex: 9,
        ...sx,
      }}
      {...rest}
    >
      <CircularProgress />
    </Box>
  );
};
